import { useNavigate } from 'react-router-dom';
import BackButton from './BackButton';
import './ConfPage.css';
import React, { useState, useEffect } from 'react';

const ConfPage = () => {
    const navigate = useNavigate();
  
    const [loading, setLoading] = useState(false);
    useEffect(() => {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 700);
    }, []);
  
    return (
      <div className="container">
        {loading ? (
          <div className="loader-container">
              <div className="spinner"></div>
          </div>
        ) : (
      <div className="item-page-four">
        <div className="overlay"></div>
      <div className="grid-three">
                    <p className="nft">Чаты</p>
                    <p className="nft">Плейсы</p>
                </div>
        <BackButton onClick={() => navigate('/fork')} />
      </div>
      )}
      </div>
    );
  };
  
  export default ConfPage;